import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';

let timeout = null

export function SearchOnPlatform({}) {
    const [results, setResults] = useState([])
    const [refInput, setRefInput] = useState(null)

    let updateQuery = (value) => {

        timeout = setTimeout(() => {
            if(!value) {
                setResults([])
                return
            }
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", "/ajax/search-on-platform", true);
            xhttp.onreadystatechange = function() {
                try{
                    setResults(JSON.parse(this.responseText));
                    window.trackEvent('SEARCH_HOME', { query: value})
                } catch (exception) {
                    console.log(exception)
                }

            };
            xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhttp.send(`query=${value}`);
        }, 500)
    }

    let goToCourse = (slug) => {
        window.trackEvent('SEARCH_HOME_CLICK', { slug })
        location.href = `/asignatura/${slug}`
    }


    return(
        <div id="search-on-platform-wrapper">
            <div style={{
                display: 'flex',
            }}>
                <input ref={r => setRefInput(r)} type="text" placeholder="¿Qué quieres aprender?" onChange={(e) => updateQuery(e.target.value)} />
                {results.length > 0 && (
                    <div
                        onClick={() => {
                            setResults([])
                            refInput.value = ''
                        }}
                        style={{
                            cursor: 'pointer',
                            postion: 'absolute',
                            marginLeft: '-24px',
                            marginTop: '20px',
                            fontSize: 22,
                            color: 'white',
                        }}>X</div>

                )}

            </div>

            {results.length > 0 && (
                <div
                    style={{
                        position: 'absolute',
                    }}
                    className="results">
                    {results.map(a => {
                        return (<div
                            id="results_search"
                            key={`result_${Math.random()}`}
                            onClick={() => goToCourse(a.slug)}
                            className="item">
                                {a.career.university.name} / {a.career.name} / {a.name}
                        </div>)
                    })}
                </div>
            )}


        </div>
    )
}

if (document.getElementById('search-on-platform')) {
    ReactDOM.render(<SearchOnPlatform />, document.getElementById('search-on-platform'));
}
